<template>
  <v-app>
    <v-app-bar
      app
      color="primary"
      dark
    >
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-toolbar-title
            v-bind="attrs"
            v-on="on"
          >
            <v-avatar tile size="30">
              <v-img src="./assets/FS Logo.png" class="rounded"></v-img>
            </v-avatar>
            {{ title }}
          </v-toolbar-title>
        </template>
        <span>
          {{ title }}
        </span>
      </v-tooltip>

      <v-spacer></v-spacer>

      <v-btn v-if="is_logged_in" icon @click="logout"><v-icon>mdi-logout</v-icon></v-btn>
    </v-app-bar>

    <v-main>
      <v-fade-transition appear hide-on-leave leave-absolute>
        <router-view name="default" key="site-router" />
      </v-fade-transition>

      <error-dialog />

      <finished-dialog />
    </v-main>

    <v-footer app color="primary" dark>
      <v-row justify="center" no-gutters dense>
        <v-col cols="auto" class="caption">
          <v-btn x-small href="https://www.growmark.com/Portals/0/Documents/GMKPrivacyPolicy.pdf" target="_blank" color="white" plain>
            <span>Privacy Policy</span>
            <v-icon right x-small>mdi-open-in-new</v-icon>
          </v-btn>
          <v-btn x-small href="https://www.growmark.com/Portals/0/Documents/GMKTermsofUse.pdf" target="_blank" color="white" plain>
            <span>Terms of Service</span>
            <v-icon right x-small>mdi-open-in-new</v-icon>
          </v-btn>
        </v-col>
        <v-spacer />
        <v-col cols="auto" class="caption">
          <span>GROWMARK, Inc.</span>
          <v-icon x-small left right>mdi-copyright</v-icon>
          <span>{{ new Date().getFullYear() }}</span>
        </v-col>
      </v-row>
    </v-footer>
  </v-app>
</template>

<script lang="ts">
  import { signOut } from "aws-amplify/auth";
  import { computed, defineComponent } from "vue";
  import { useRoute, useRouter } from 'vue-router/composables';
  import { useGetters } from '~/store/user';
  import finishedDialog from "./components/finished-dialog.vue";
  import errorDialog from "./components/error-dialog.vue";

  export default defineComponent({
    name: 'main-application',
    components: {
      'finished-dialog': finishedDialog,
      'error-dialog': errorDialog
    },
    setup () {
      const route = useRoute();

      const { identity } = useGetters(['identity', 'redirect_sso']);
      const title = computed(() => route?.meta?.title || "GROWMARK Solution Center");
      const is_logged_in = computed(() => !!identity.value);

      const logout = async () => {
        console.log('Signing out');
        await signOut({ global: true });
      };

      return {
        title,
        is_logged_in,
        logout
      };
    }
  });
</script>